<template>
    <div class="table_wrap">
        <SearchForm :data="searchForm" ref="searchForm" v-if="searchForm.length"></SearchForm>
        <el-table :ref="tableRef" :data="tableList.data" v-bind="propsObj" v-on="onEvents" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
            <div slot="empty">
				<template v-if="showEmptyTable">
					<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
				</template>
				<template v-else>
					暂无数据
				</template>
            </div>
            <template v-for="(item, index) in headerList" >
                <el-table-column :key="index" v-on="item.on" v-bind="item.props" v-if="!item.props.type"> 
                    <template slot="header" slot-scope="scope">
                        <template v-if="item.renderHeader">
                            <useTableColumn :renderHtml="item.renderHeader" :scope="scope"></useTableColumn>
                        </template>
                        <template v-else>
                            {{item.props.label}}
                        </template> 
                    </template>
                    <template slot-scope="scope">
                        <template v-if="item.render">
                            <useTableColumn :renderHtml="item.render" :scope="scope"></useTableColumn>
                        </template>
                        <span v-else>{{scope.row[item.props.prop]}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-else  :key="index" v-on="item.on" v-bind="item.props"></el-table-column>
            </template>
           
        </el-table>
        <Pagination @change="changeSize" @sizeChange="onsizeChange" :total="tableList.total" :pageSizes="paginationObj.pageSizes" :layout="paginationObj.layout" :pageSize="searchObj.pageSize" ref="pagination" v-model="searchObj.page" v-if="(tableList.total&&alwaysShowPagination) || Math.ceil(tableList.total / searchObj.pageSize) > 1"></Pagination>
    </div>
</template>
<script>
import useTableColumn from './useTableColumn.jsx'
import SearchForm from './searchForm'
import Pagination from '../pagination/pagination.vue'
export default {
    props: {
        headerList: {
            type: Array,
            default: () => []
        },
        searchForm: {
            type: Array,
            default: () => []
        },
        httprequest: {
            type: Function,
            default: () => {
                return () => {}
            }
        },
        propsObj:{
            type: Object,
            default: () => {}
        },
        onEvents: {
            type: Object,
            default: () => {}
        },
		showEmptyTable: {
            type: Boolean,
            default: true
        },
        tableRef: {
			type: String,
			default:''
		},
        paginationObj: { // 分页相关
            type: Object,
            default: () => {
                return {
                    pageSizes: [],
                    layout: 'total, prev, pager, next'
                }
            }
        },
        alwaysShowPagination: { //有数据的时候页签常显
            type: Boolean,
            default: false
        }
    },
    created() {
        this.$nextTick(() => {
            this.getRequestRes()
        })
    },
    components: {
        useTableColumn,
        SearchForm,
        Pagination
    },
    methods: {
        async getRequestRes(type) {
            if(type === 'firstPage') {
                this.searchObj.page = 1
            }
			let res = ''
			if(this.searchForm.length){
				res = await this.httprequest({...this.$refs.searchForm.ruleForm, ...this.searchObj})
			} else {
				res = await this.httprequest({...this.searchObj})
			}
            
            this.tableList = res
        },
        // 修改当前页码
        changeSize(size) {
            this.searchObj.page = size
            this.getRequestRes()
        },
        // 修改每页条数
        onsizeChange(currentPageSize){
            this.searchObj.pageSize = currentPageSize
            this.searchObj.page_size = currentPageSize
            this.searchObj.page = 1
            this.getRequestRes()
        }
    },
    data() {
        return {
            noDataName: 'empty',
            searchObj: {
                pageSize: 10,
                page: 1,
                page_size: 10
            },
            tableList: {
                data: [],
                total: 0
            }
        }
    },
   }
</script>
<style lang="less" scoped>
    .table_wrap {
        .el-table {
            &::before {
                background: none;
            }
        }
    }
</style>
